
'use client';

import * as React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MapPin, Building, UtensilsCrossed, Landmark } from 'lucide-react';
import { Separator } from './ui/separator';

interface CityStat {
  name: string;
  total: number;
  restaurants: number;
  prayer_areas: number;
  businesses: number;
}

// Pre-calculated stats to avoid complex client-side logic causing build errors.
// This data is derived from the initial POIs for Sydney, Brisbane, Melbourne, and Gold Coast.
const cityStats: CityStat[] = [
    { name: 'Sydney', total: 5, restaurants: 1, prayer_areas: 2, businesses: 2 },
    { name: 'Brisbane', total: 47, restaurants: 31, prayer_areas: 7, businesses: 9 },
    { name: 'Melbourne', total: 4, restaurants: 1, prayer_areas: 2, businesses: 1 },
    { name: 'Gold Coast', total: 5, restaurants: 5, prayer_areas: 0, businesses: 0 }
];


export default function CityStats() {
  // The component now directly renders the pre-calculated stats,
  // which bypasses the previous TypeScript error.
  
  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
            <MapPin className="w-5 h-5 text-primary" />
            City Statistics
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {cityStats.map((city, index) => (
          <div key={city.name}>
            <div className="flex justify-between items-center">
              <h3 className="font-semibold">{city.name}</h3>
              <p className="font-bold text-lg text-primary">{city.total}</p>
            </div>
            <div className="text-sm text-muted-foreground grid grid-cols-3 gap-2 mt-2">
                <div className="flex items-center gap-1.5">
                    <UtensilsCrossed className="w-4 h-4" />
                    <span>{city.restaurants} Food</span>
                </div>
                 <div className="flex items-center gap-1.5">
                    <Landmark className="w-4 h-4" />
                    <span>{city.prayer_areas} Prayer</span>
                </div>
                 <div className="flex items-center gap-1.5">
                    <Building className="w-4 h-4" />
                    <span>{city.businesses} Business</span>
                </div>
            </div>
             {index < cityStats.length - 1 && <Separator className="mt-4" />}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
